/** Average Gregorian year length in ms (365.25 days). */
const MS_PER_YEAR = 31557600000;

/**
 * Parse DOB from Firestore Timestamp, { seconds }, or date string.
 * @returns {Date|null}
 */
export const parseDOB = (dobVal) => {
  if (!dobVal) return null;
  if (typeof dobVal.toDate === "function") return dobVal.toDate();
  if (typeof dobVal.seconds === "number") return new Date(dobVal.seconds * 1000);
  const d = new Date(dobVal);
  return isNaN(d.getTime()) ? null : d;
};

/**
 * Decimal age in years from DOB to reference date (defaults to now).
 * @returns {number|null}
 */
export const calculateDecimalAge = (dobVal, referenceDate = new Date()) => {
  const dob = parseDOB(dobVal);
  if (!dob) return null;
  const ref = referenceDate instanceof Date ? referenceDate : new Date(referenceDate);
  if (isNaN(ref.getTime())) return null;
  const ageYears = (ref - dob) / MS_PER_YEAR;
  return ageYears >= 0 ? ageYears : null;
};

/**
 * Numeric age rounded to one decimal for storage/sorting.
 * @returns {number|null}
 */
export const getProfileAgeNumber = (dobVal, storedAge) => {
  const calculated = calculateDecimalAge(dobVal);
  if (calculated != null && !isNaN(calculated)) {
    return parseFloat(calculated.toFixed(1));
  }
  if (storedAge != null && storedAge !== "" && !isNaN(parseFloat(storedAge))) {
    return parseFloat(parseFloat(storedAge).toFixed(1));
  }
  return null;
};

/**
 * Profile age for display — one decimal place (e.g. "17.4", "18.0").
 * @returns {string}
 */
export const formatProfileAge = (dobVal, storedAge, empty = "--") => {
  if (parseDOB(dobVal)) {
    const calculated = calculateDecimalAge(dobVal);
    if (calculated != null && !isNaN(calculated)) {
      return calculated.toFixed(1);
    }
  }
  if (
    storedAge !== 0.0 &&
    storedAge != null &&
    storedAge !== "" &&
    !isNaN(parseFloat(storedAge))
  ) {
    return parseFloat(storedAge).toFixed(1);
  }
  return empty;
};
